"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const index_1 = tslib_1.__importDefault(require("./index"));
/**
 * This component allows - and empty values as intermediery values
 * it calls change only with valid numeric values
 */
const NumberInput = (props) => {
    const [value, setValue] = React.useState(() => {
        var _a;
        // awlays controlled
        return (_a = props.value) !== null && _a !== void 0 ? _a : '';
    });
    const handleChange = React.useCallback((event) => {
        const { value } = event.target;
        let newVal = Number(value);
        if (value === '-' || value === '') {
            // we are saving invalid values so we allow values as empty string and '-'
            // there is a validation that prevents the
            newVal = value;
            // the value may be empty or negative
            setValue(value);
        }
        else if (!isNaN(newVal)) {
            setValue(value);
            // only set when a valid numer
            props.onChange(newVal);
        }
    }, []);
    React.useEffect(() => {
        setValue(props.value);
    }, [props.value]);
    const handleBlur = React.useCallback((event) => {
        var _a;
        (_a = props === null || props === void 0 ? void 0 : props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, event);
        // show the prop value
        if (value !== props.value) {
            setValue(props.value);
        }
    }, [props.value, value]);
    return React.createElement(index_1.default, Object.assign({}, props, { value: value, onBlur: handleBlur, onChange: handleChange }));
};
exports.NumberInput = NumberInput;
